import { Component, OnInit, OnDestroy, inject, ChangeDetectorRef, PLATFORM_ID, ChangeDetectionStrategy } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import packageJson from '../../../../package.json';
import { ThemeService } from '@core/services/theme.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styleUrl: './login-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LoginLayoutComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly cdr = inject(ChangeDetectorRef);
  private platformId = inject(PLATFORM_ID);
  private themeService = inject(ThemeService);

  public version: string = packageJson.version;

  backgroundImage: string = 'assets/images/backgrounds/cloud-security.jpg';

  private backgroundImages: string[] = [
    'assets/images/backgrounds/cloud-security.jpg',
    'assets/images/backgrounds/cyber-security-solutions.jpg',
    'assets/images/backgrounds/technology-services.jpg',
    'assets/images/backgrounds/datacenter.png',
  ];

  // Initialize to stable values to avoid undefined->value flips
  spinnerShow = true;
  isSelectPlanLayout = false;

  constructor() {
    // Use cryptographically secure random for background selection
    if (isPlatformBrowser(this.platformId) && typeof window !== 'undefined' && window.crypto) {
      const randomArray = new Uint32Array(1);
      window.crypto.getRandomValues(randomArray);
      const randomIndex = randomArray[0] % this.backgroundImages.length;
      this.backgroundImage = this.backgroundImages[randomIndex];
    } else {
      // Fallback to Math.random for SSR
      const randomIndex = Math.floor(Math.random() * this.backgroundImages.length);
      this.backgroundImage = this.backgroundImages[randomIndex];
    }
  }

  ngOnInit(): void {
    // Defer subscriptions to avoid NG0100 during initial render
    setTimeout(() => this.initSubscriptions(), 0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Initialize theme subscriptions after initial render to avoid NG0100
   */
  private initSubscriptions(): void {
    this.themeService.getShowSpinner()
      .pipe(takeUntil(this.destroy$))
      .subscribe((showSpinner) => {
        if (this.spinnerShow !== showSpinner) {
          this.spinnerShow = showSpinner;
          this.cdr.detectChanges();
        }
      });

    this.themeService.getSelectPlanPage()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isSelectPlan) => {
        if (this.isSelectPlanLayout !== isSelectPlan) {
          this.isSelectPlanLayout = isSelectPlan;
          this.cdr.detectChanges();
        }
      });
  }
}
